
import Typography from '@mui/material/Typography'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import clsx from 'clsx'

import styles from './SubscriptionGiftStepper.module.css'
import { Box } from '@mui/material'

export interface SubscriptionGiftStepperProps {
    activeStep: number
}

const SubscriptionGiftStepperStep = (props: SubscriptionGiftStepperProps) => {
    const steps = [`RECIPIENT'S DETAILS`, `CUSTOMISE YOUR GIFT`, `YOUR DETAILS`, `PAYMENT`]

    return (
        <Box className={styles.box}>
            {steps.map((step, index) => (
                <Box className={styles.box} key={step}>
                    <div className={clsx(
                        { [styles.circleIconActive]: (index <= props.activeStep) },
                        { [styles.circleIcon]: (index > props.activeStep) },
                    )}>
                        <Typography>{index + 1}</Typography>
                    </div>
                    <Typography className={styles.stepperText}>{step}</Typography>
                    {index + 1 < steps.length && <KeyboardArrowRightIcon className={clsx(
                        { [styles.pointerActive]: (index <= props.activeStep) },
                        { [styles.pointer]: (index > props.activeStep) },
                    )}/>}
                </Box>
            ))}

        </Box>
    )
}

export default SubscriptionGiftStepperStep